export default __webpack_public_path__ + "static/media/guest_06_camila_almeida.b96d1304.png";